var _Path, _Path2, _Path3, _Path4, _Path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDietNutrition = function SvgDietNutrition(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M44.775 4.825a10.476 10.476 0 0 0-9.225 10.4V34.1h9.225V4.825ZM36.851 6.05a12.975 12.975 0 0 1 9.174-3.8c.69 0 1.25.56 1.25 1.25v31.85c0 .69-.56 1.25-1.25 1.25H34.3c-.69 0-1.25-.56-1.25-1.25V15.225c0-3.441 1.367-6.741 3.8-9.175Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M37.95 35.175c0-.69.56-1.25 1.25-1.25h6.825c.69 0 1.25.56 1.25 1.25v14.7A4.575 4.575 0 0 1 42.7 54.45h-.175a4.575 4.575 0 0 1-4.575-4.575v-14.7Zm2.5 1.25v13.45a2.075 2.075 0 0 0 2.075 2.075h.175a2.075 2.075 0 0 0 2.075-2.075v-13.45H40.45Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M13.279 27.2a1.25 1.25 0 0 1 1.246-1.15h4.725c.651 0 1.194.5 1.246 1.15l1.75 21.875c.002.032.004.065.004.098a5.275 5.275 0 0 1-5.477 5.276 5.275 5.275 0 0 1-5.248-5.275c0-.033.001-.066.004-.1l1.75-21.874Zm2.4 1.35-1.654 20.67a2.775 2.775 0 0 0 2.829 2.73 2.775 2.775 0 0 0 2.895-2.73l-1.653-20.67h-2.417Z",
    clipRule: "evenodd"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M13.279 27.2a1.25 1.25 0 0 1 1.246-1.15h4.725c.651 0 1.194.5 1.246 1.15l1.75 21.875c.002.032.004.065.004.098a5.275 5.275 0 0 1-5.477 5.276 5.275 5.275 0 0 1-5.248-5.275c0-.033.001-.066.004-.1l1.75-21.874Zm2.4 1.35-1.654 20.67a2.775 2.775 0 0 0 2.829 2.73 2.775 2.775 0 0 0 2.895-2.73l-1.653-20.67h-2.417Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M7.803 18.608a1.25 1.25 0 0 1 .947-.434h15.925a1.25 1.25 0 0 1 1.236 1.434 9.3 9.3 0 0 1-18.397 0 1.25 1.25 0 0 1 .29-1Zm2.56 2.066a6.799 6.799 0 0 0 12.7 0h-12.7Z",
    clipRule: "evenodd"
  }), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M7.803 18.608a1.25 1.25 0 0 1 .947-.434h15.925a1.25 1.25 0 0 1 1.236 1.434 9.3 9.3 0 0 1-18.397 0 1.25 1.25 0 0 1 .29-1Zm2.56 2.066a6.799 6.799 0 0 0 12.7 0h-12.7Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M8.75 3.65c.69 0 1.25.56 1.25 1.25v14.524a1.25 1.25 0 1 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25Z",
    clipRule: "evenodd"
  }), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M8.75 3.65c.69 0 1.25.56 1.25 1.25v14.524a1.25 1.25 0 1 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M16.625 3.65c.69 0 1.25.56 1.25 1.25v14.175a1.25 1.25 0 1 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25Z",
    clipRule: "evenodd"
  }), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M16.625 3.65c.69 0 1.25.56 1.25 1.25v14.175a1.25 1.25 0 1 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M24.675 3.65c.69 0 1.25.56 1.25 1.25v14.525a1.25 1.25 0 0 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25Z",
    clipRule: "evenodd"
  }), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M24.675 3.65c.69 0 1.25.56 1.25 1.25v14.525a1.25 1.25 0 0 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25Z",
    clipRule: "evenodd"
  })));
};
export default SvgDietNutrition;